import _ from "lodash"

export const getFpxBank = fpx => _.get(fpx,['bank'],null)
export const getFpxClientName = fpx => _.get(fpx,['client_name'],"")
export const getFpxGatewayTransactionID = fpx => _.get(fpx,['gateway_transaction_id'],null)
export const getFpxCurrency = fpx => _.get(fpx,['currency'],'')

export const getFpxPaidAmount = fpx => getFpxCurrency(fpx) + _.get(fpx,['paid_amount'],0).toString()
export const getFpxPaidAt = fpx => _.get(fpx,['paid_at'],'')
export const getFpxReference = fpx => _.get(fpx,['reference'],'')
export const getFpxStatus = fpx => _.get(fpx,['status'],'')
